import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import ContactUsComp from '../Components/ContactUsComp/ContactUsComp'

const ContactUsCompPage = () => {
  return (
    <>
    <Header/>
    <ContactUsComp/>
    <Footer/>
    
    </>
  )
}

export default ContactUsCompPage